import { useMutation } from 'react-query';
import axios from 'axios';

import { useAppSelector } from '@/app/hooks';
import { EditSegmentDetails } from '@/models/Segments';
import { useAuth } from '@/modules/Auth/hooks/useAuth';
import { selectCurrentWorkspace } from '@/modules/Dashboard/Workspaces/workspaceSlice';
import { AwsConfigApiGateway } from '@/utils/config/api';

async function editDataDrivenSegment(
  data: EditSegmentDetails,
  token: string | undefined,
  workspaceId: string,
  segmentId: string,
) {
  const response = await axios.put<EditSegmentDetails>(
    `${AwsConfigApiGateway.pooledTenantApiUrl}/workspaces/${workspaceId}/segments/${segmentId}`,
    data,
    {
      headers: {
        'x-api-key': AwsConfigApiGateway.pooledTenantApiKey,
        Authorization: 'Bearer ' + token,
      },
    },
  );
  return response.data;
}

export function useEditDataDrivenSegment() {
  const { user } = useAuth();
  const workspace = useAppSelector(selectCurrentWorkspace);
  return useMutation<EditSegmentDetails, Error, EditSegmentDetails>((data) =>
    editDataDrivenSegment(data, user?.signInUserSession.idToken.jwtToken, workspace?.id ?? '', data.id),
  );
}
